import Swiper from 'swiper/bundle'

export class Carousel {

    constructor ( target = '.js-carousel', options = {} ) {

        this.target = target;

        this.options = {
            slidesPerView: 1,
            spaceBetween: 35,
            slideClass: 'js-carousel__slide',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__slide--active',
            noSwipingClass: 'js-carousel__no-swipe',
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init () {

        this.sliders = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );

        if(this.el.length > 0) {
            this.sliderObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this )
            }, this.observerOptions );

            this.el.forEach( $el => {
                this.sliderObserver.observe( $el );
            } );
        }

    }

    create( entries, instance) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {

                const $el = entry.target;
                const count = Array.from( $el.querySelectorAll( `.${this.options.slideClass}` ) ).length;
                const items = parseInt($el.dataset.items);

                let options;

                let $next = '.js-carousel__next';
                let $prev = '.js-carousel__prev';

                if ( count > 1 && items ) {
                    if ( items >= 4 ) {
                        options = {
                            ...this.options,
                            navigation: {
                                nextEl: $next,
                                prevEl: $prev,
                                disabledClass: 'js-carousel__control--disabled',
                            },
                            breakpoints: {
                                480: {
                                    slidesPerView: 1
                                },
                                720: {
                                    slidesPerView: 2
                                },
                                1330: {
                                    slidesPerView: 3
                                },
                                1420: {
                                    slidesPerView: 4
                                },
                            }
                        }
                    } else if ( items == 3 ){
                        options = {
                            ...this.options,
                            navigation: {
                                nextEl: $next,
                                prevEl: $prev,
                                disabledClass: 'js-carousel__control--disabled',
                            },
                            breakpoints: {
                                720: {
                                    slidesPerView: 1
                                },
                                1330: {
                                    slidesPerView: 2
                                },
                                1420: {
                                    slidesPerView: 3
                                },
                            }
                        }
                    }
                    else if ( items <= 2 ){
                        options = {
                            ...this.options,
                            navigation: {
                                nextEl: $next,
                                prevEl: $prev,
                                disabledClass: 'js-carousel__control--disabled',
                            },
                            breakpoints: {
                                720: {
                                    slidesPerView: 1
                                },
                                1330: {
                                    slidesPerView: 2
                                },
                            }
                        }
                    }
                } else if ( count > 1 && !items ) {
                    options = {
                        ...this.options,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__control--disabled',
                        }
                    }
                } else {
                    options = {
                        ...this.options,
                    }
                    const $controls = $el.querySelector( `.c-swiper__controls` );
                    if($controls) {
                        $controls.remove();
                    }
                }

                // Pinched from the Showground
                const swiper = new Swiper( $el, options );
                $el.swiper = swiper;

                if ( $el.parentNode.classList.contains( 'o-sideload__main' ) ) {
                    const header = document.querySelector( '.o-sideload__intro' );
                    swiper.on( 'slideChange', () => {
                        if ( window.matchMedia( '(min-width: 65em)' ).matches ) {
                            if ( swiper.activeIndex > 0 ) {
                                header.classList.add( 'js--faded' );
                            } else {
                                header.classList.remove( 'js--faded' );
                            }
                        }
                    } );
                }

                this.sliders.push( new Swiper( $el, options ) );

            }
        })
    }

    destroy () {
        if(this.el.length > 0) {
            this.sliderObserver.disconnect();
        }
        this.sliders.forEach( slider => {
            slider.destroy();
        } )
    }
}